module.exports = __webpack_public_path__ + "static/img/icon_check.01dc5cc5.svg";